import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import ReactHighcharts from 'react-highcharts';
import {injectIntl} from 'react-intl';
import getTranslatedText from '../../services/getTranslatedText';

const styles = {
  wrapper: {
    padding: 15
  },
};

class NpsByAnswerToOtherQuestionBarChart extends Component {
  render() {
    const intl = this.props.intl;
    const answersReport = this.props.answersReport;
    const npsByAnswerToOtherQuestion = answersReport ? answersReport.npsByAnswerToOtherQuestion : [];

    const categories = npsByAnswerToOtherQuestion.map(item => getTranslatedText(item.text, intl.locale));
    const data = npsByAnswerToOtherQuestion.map(item => item.nps);

    const chartConfig = {
      chart: {
        type: 'bar',
        height: this.props.height-(styles.wrapper.padding*2),
        width: this.props.width-(styles.wrapper.padding*2),
      },
      title: {
        text: intl.formatMessage({id: 'npsByAnswerToOtherQuestion'}),
        margin: 5,
        style: {
          fontSize: '14px',
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        formatter: function() {
          const index = categories.findIndex(x => x === this.x);
          return intl.formatMessage({
            id: 'numberOfAnswers',
          },{
            count: npsByAnswerToOtherQuestion[index].count,
          });
        },
      },
      xAxis: {
        categories,
      },
      yAxis: {
        visible: false,
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            format: '{y:.0f}',
          },
          pointPadding: 0,
          groupPadding: 0.1,
        },
      },
      series: [{
        data,
      }],
    };
    return (
      <div style={styles.wrapper}>
        <ReactHighcharts
          config={chartConfig}
          domProps={{id: this.props.uniqueId}}
        />
      </div>
    );
  }
}

export default createFragmentContainer(
  injectIntl(NpsByAnswerToOtherQuestionBarChart),
  graphql`
    fragment NpsByAnswerToOtherQuestionBarChart_answersReport on AnswersReport {
      npsByAnswerToOtherQuestion(
        otherQuestionMongoId: $otherQuestionMongoId
      ) {
        text {
          language
          text
        }
        nps
        count
      }
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/NpsByAnswerToOtherQuestionBarChart/NpsByAnswerToOtherQuestionBarChart.js